var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.7 10.5h-1.4V7.2c0-1.4-.5-2.7-1.5-3.7S13.5 2 12.1 2c-1.4 0-2.7.5-3.7 1.5S6.8 5.8 6.8 7.2v3.3H5.4C4 10.5 3 11.6 3 13v6.6C3 20.9 4 22 5.4 22h13.3c1.3 0 2.4-1.1 2.4-2.4V13c-.1-1.4-1.1-2.5-2.4-2.5zM7.8 7.2c0-1.1.4-2.2 1.2-3 .8-.8 1.9-1.2 3-1.2s2.2.4 3 1.2c.8.8 1.2 1.9 1.2 3v3.3H7.8V7.2zM20 19.6c0 .8-.6 1.4-1.4 1.4H5.4c-.8 0-1.4-.6-1.4-1.4V13c0-.8.6-1.4 1.4-1.4h13.3c.8 0 1.4.6 1.4 1.4v6.6z"}));
}

Lock.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Lock;

Lock.default = Lock;
